import ProjectCompo from '../components/Projects';

const Projects = () => {
    return (
        <div className="px-4 container mx-auto flex flex-col gap-8 items-center mt-24">
        <ProjectCompo />
        </div>
    );
}

export default Projects;